import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc8ff7a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clinical-coaching-card-wrapper" }
const _hoisted_2 = { class: "heading heading-sm" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "heading heading-sm" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-icon" }
const _hoisted_8 = { class: "col-body" }
const _hoisted_9 = { class: "apt-date" }
const _hoisted_10 = { class: "upcoming-coach" }
const _hoisted_11 = { class: "heading heading-sm" }
const _hoisted_12 = { class: "heading heading-sm" }
const _hoisted_13 = { class: "description" }
const _hoisted_14 = { class: "heading heading-sm" }
const _hoisted_15 = { class: "description" }
const _hoisted_16 = { class: "heading heading-sm" }
const _hoisted_17 = { class: "description" }
const _hoisted_18 = { class: "heading heading-sm" }
const _hoisted_19 = { class: "description" }
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, "|", -1))
const _hoisted_22 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconChecklist = _resolveComponent("IconChecklist")!
  const _component_IconInfo = _resolveComponent("IconInfo")!
  const _component_IconStar = _resolveComponent("IconStar")!
  const _component_IconCalendar = _resolveComponent("IconCalendar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconVideo = _resolveComponent("IconVideo")!
  const _component_CardCircleIcon = _resolveComponent("CardCircleIcon")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showCard)
      ? (_openBlock(), _createBlock(_component_CardCircleIcon, {
          key: 0,
          class: "clinical-coaching-card",
          cardCircleColor: _ctx.cardCircleColor
        }, {
          icon: _withCtx(() => [
            (_ctx.currentCardState === _ctx.cardStateTypes.INITIAL)
              ? (_openBlock(), _createBlock(_component_IconChecklist, {
                  key: 0,
                  class: "card-icon icon-checklist"
                }))
              : (_ctx.currentCardState === _ctx.cardStateTypes.EXPIRED || _ctx.currentCardState === _ctx.cardStateTypes.DEACTIVATED)
                ? (_openBlock(), _createBlock(_component_IconInfo, {
                    key: 1,
                    class: "card-icon icon-info"
                  }))
                : (_ctx.currentCardState === _ctx.cardStateTypes.COMPLETED)
                  ? (_openBlock(), _createBlock(_component_IconStar, {
                      key: 2,
                      class: "card-icon icon-star"
                    }))
                  : (_openBlock(), _createBlock(_component_IconCalendar, {
                      key: 3,
                      class: "card-icon"
                    }))
          ]),
          default: _withCtx(() => [
            (_ctx.currentCardState === _ctx.cardStateTypes.INITIAL)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('initial.heading')), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('initial.body')), 1),
                  _createVNode(_component_router_link, {
                    class: "btn-cta btn-secondary",
                    to: { name: 'ClinicalCoachingGetStarted' },
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackGetStartedClick()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('initial.buttonGetStarted')), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_ctx.currentCardState === _ctx.cardStateTypes.UPCOMING && _ctx.showCard)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.card.title), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_IconVideo, { class: "icon icon-video" })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.longFormatDate(_ctx.startTime)), 1)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.card.description), 1)
                    ]),
                    (_ctx.showCancel)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn-cta btn-secondary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCancelModal()))
                        }, _toDisplayString(_ctx.$t('upcoming.buttonCancel')), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_ctx.currentCardState === _ctx.cardStateTypes.STARTING_SOON && _ctx.showCard)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.subStartTime(_ctx.card.title, _ctx.startTime)), 1),
                      _createVNode(_component_router_link, {
                        class: "btn-cta btn-primary",
                        to: { name: 'Conference' },
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.joinSessionClick()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('starting_soon.buttonJoin')), 1)
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_ctx.currentCardState === _ctx.cardStateTypes.SCHEDULE_NEXT)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('schedule_next.heading')), 1),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('schedule_next.body')), 1),
                        _createVNode(_component_router_link, {
                          class: "btn-cta btn-secondary",
                          to: { name: 'ClinicalCoachingSchedule' },
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackScheduleClick()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('schedule_next.buttonSchedule')), 1)
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_ctx.currentCardState === _ctx.cardStateTypes.SCHEDULE_BOOSTER)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('schedule_booster.heading')), 1),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('schedule_booster.body')), 1),
                          _createVNode(_component_router_link, {
                            class: "btn-cta btn-secondary",
                            to: { name: 'ClinicalCoachingSchedule' },
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trackScheduleClick()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('schedule_booster.buttonSchedule')), 1)
                            ]),
                            _: 1
                          })
                        ], 64))
                      : (_ctx.currentCardState === _ctx.cardStateTypes.COMPLETED)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('completed.heading')), 1),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('completed.body')), 1)
                          ], 64))
                        : (_ctx.currentCardState === _ctx.cardStateTypes.EXPIRED || _ctx.currentCardState === _ctx.cardStateTypes.DEACTIVATED)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('expired.heading')), 1),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('expired.body')), 1),
                              _createElementVNode("a", {
                                class: "btn-cta btn-link no-underline link-mailto",
                                href: _ctx.expiredContactMailto
                              }, _toDisplayString(_ctx.$t('expired.linkContact')), 9, _hoisted_20),
                              _hoisted_21,
                              _createVNode(_component_router_link, {
                                class: "btn-cta btn-link no-underline",
                                to: { name: 'ClinicalCoachingAbout' }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('expired.linkMoreInfo')), 1)
                                ]),
                                _: 1
                              })
                            ], 64))
                          : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["cardCircleColor"]))
      : _createCommentVNode("", true),
    _createVNode(_component_BaseModal, {
      class: "appointment-cancel-choice-modal",
      title: _ctx.$t('modal.cancelAppointment.title'),
      showCloseButton: true,
      showModal: _ctx.cancelModalShown,
      "onUpdate:showModal": _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancelModalShown = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "action action-yes btn-primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelUpcomingAppointment && _ctx.cancelUpcomingAppointment(...args)))
          }, _toDisplayString(_ctx.$t('modal.cancelAppointment.yes')), 1),
          _createElementVNode("button", {
            class: "action action-no btn-ghost",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideCancelModal && _ctx.hideCancelModal(...args)))
          }, _toDisplayString(_ctx.$t('modal.cancelAppointment.no')), 1)
        ])
      ]),
      _: 1
    }, 8, ["title", "showModal"])
  ]))
}